import * as React from 'preact/compat'

import type { SearchItemProps } from '#components/Search/SearchPanel'

import SearchItemGame from './SearchItemGame'
import SearchItemSeries from './SearchItemSeries'

export default ({ item, isLoggedIn }: SearchItemProps) => {
  if (item.type === 'series') {
    return <SearchItemSeries item={item}/>
  }
  return <SearchItemGame item={item} isLoggedIn={isLoggedIn}/>
}
